.onlineServices {
  background-color: var(--pgm-sys-color-surface);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  margin: 0 auto;
  max-width: 1440px;
  padding: var(--pgm-sys-spacing-10) var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-16);
  width: 100%;
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-2) 0;
}

.overline {
  color: var(--pgm-sys-color-primary);
  margin: 0;
  text-transform: uppercase;
}

.subtitle {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

.list {
  display: grid;
  gap: var(--pgm-sys-spacing-6);
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.card {
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  padding: var(--pgm-sys-spacing-4);
  position: relative;
}

.badge {
  background-color: var(--pgm-sys-color-primary-container);
  border-radius: 4px;
  color: var(--pgm-sys-color-on-primary-container);
  padding: var(--pgm-sys-spacing-1) var(--pgm-sys-spacing-2);
  position: absolute;
  right: var(--pgm-sys-spacing-4);
  top: var(--pgm-sys-spacing-6);
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-3);
}

.cardTitle,
.cardDescription {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.cardActions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--pgm-sys-spacing-3);
  margin-top: auto;
  padding: var(--pgm-sys-spacing-1) 0;
}

@media (max-width: 1024px) {
  .list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .list {
    grid-template-columns: minmax(0, 1fr);
  }
}
